import { RootState } from "@/redux/store"
import { useGetGroupGlListByGroupGlYear } from "@/services"
import { useQueryClient } from "@tanstack/react-query";
import { useEffect, useMemo } from "react";
import { useSelector } from "react-redux";

const useViewGroupGl = ({groupGlMasterId}: {groupGlMasterId: string}) => {
  const communityData = useSelector((state: RootState) => state.currentData.communityData);
  const currentFinanceYear = useSelector((state: RootState) => state.currentData.currentFinanceYear);
  const distributionJobDtl = useSelector((state: RootState) => state.currentData.distributionJobDtl);
  const queryClient = useQueryClient();
  
  useEffect(() => {
    queryClient.cancelQueries({queryKey: ["group-gl-list", groupGlMasterId, currentFinanceYear]})
  }, []);

  const {data: groupGlList, isLoading: isGroupLoading} = useGetGroupGlListByGroupGlYear({
    communityId: communityData?.communityId,
    groupGlMasterId,
    year: currentFinanceYear,
    queryParams: {
      enabled: !!groupGlMasterId
    }
  })

  const isPlanned = useMemo(() => distributionJobDtl?.budgetType?.toLowerCase() == "plan" ,[distributionJobDtl]);

  return {
    isGroupLoading,
    groupGlList: isPlanned ? groupGlList?.data?.planMembers : groupGlList?.data?.actualMembers,
  }
}

export default useViewGroupGl;